import { useEffect, useState } from "react";
import { request } from "../api/client";
import type { Unit } from "./types";

// Use the full registration-scope inventory, not the filtered/paginated stage list.
export function useRoundCapacity(unit: Unit | null, revision: number, enabled = true) {
  const id = enabled && unit?.unitKind === "STAGE" ? unit.unitId : "";
  const key = `${id}:${unit?.version}:${revision}`;
  const [state, setState] = useState<{ key: string; total?: number; error?: unknown }>();
  useEffect(() => {
    if (!id) return;
    const controller = new AbortController();
    const load = () => {
      setState({ key });
      request<{ rounds: Unit[] }>("/events/eventRoundWeights?unitId=" + encodeURIComponent(id), "GET", undefined, controller.signal)
        .then(data => { if (!controller.signal.aborted) setState({ key, total: data.rounds.reduce((sum, round) => sum + (typeof round.roundWeightBps === "number" ? round.roundWeightBps : 0), 0) }); })
        .catch(error => { if (!controller.signal.aborted) setState({ key, error }); });
    };
    load();
    return () => controller.abort();
  }, [id, key]);
  const current = state?.key === key ? state : undefined;
  return {
    canAdd: !id || (current?.total !== undefined && current.total < 10000),
    full: !!id && current?.total !== undefined && current.total >= 10000,
    error: id ? current?.error : undefined,
  };
}
